import logo from './logo.svg';
import './App.css';
import {Routes, Route, Navigate} from 'react-router-dom';
import React, { useEffect, useState, useContext } from 'react';

//pages
import NoPage from './pages/NoPage';
import Layout from './pages/Layout';

import Home from './pages/Home';
import Login from './pages/Login';
import Projects from './pages/Projects';
import Learning from './pages/Learning';
import Experience from './pages/Experience';
import Journal from './pages/Journal';
import Joy from './pages/Joy';
import Interests from './pages/Interests';
import Contact from './pages/Contact';
import Apps from './pages/Apps';
import Coffee from './pages/Coffee';
import AdminDashboard from './pages/AdminDashboard';

import ProjectsContext from './context/projects';
// import { AuthProvider } from './context/authcontext';
import ProtectedRoute from './components/ProtectedRoute';
import AnalyticsTracker from './components/AnalyticsTracker';

function App() {
    const [message] = useState('');
    const { fetchProjects } = useContext(ProjectsContext);

    useEffect(() => {
        fetchProjects();
    }, [fetchProjects]); 

    return (
      <div className="App">
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Projects" element={<Projects />} />
          <Route path="/Learning" element={<Learning />} />
          <Route path="/Experience" element={<Experience />} />
          <Route path="/History" element={<Navigate to="/Experience" replace />} />
          <Route path="/Journal" element={<Journal />} />
          <Route path="/Joy" element={<Joy />} />
          <Route path="/Interests" element={<Interests />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Apps" element={<Apps />} />
          <Route path="/Coffee" element={<Coffee />} />
          <Route 
            path="/Admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NoPage />} />
        </Route>             
      </Routes>
      <div>{message}</div>
    </div>
    );
}

export default App;